<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()">
      <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Auto Mark SAQ</h5>
    <div class="mr-0 d-flex flex-column align-items-center">
      <div class="mb-3 mr-0 col-md-10">
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="requireCaseMatching"
            [(ngModel)]="requireCaseMatching" [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label" for="requireCaseMatching">Require case matching</label>
        </div>
        <div class="form-check  mb-2">
          <input class="form-check-input" type="checkbox" id="requireStrictSpelling"
            [(ngModel)]="requireStrictSpelling" [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label" for="requireStrictSpelling">Require strict spelling</label>
        </div>
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="allowSynonyms"
            [(ngModel)]="allowSynonyms" [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label" for="allowSynonyms">Enable synonym matching</label>
        </div>
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="reassessAllScripts"
          [(ngModel)]="reassessAllScripts" [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label" for="reassessAllScripts">Reassess all scripts</label>
        </div>
      </div>
      <button class="btn btn-primary btn-lg col-md-10" (click)="autoMark()">
        Auto Mark
      </button>
    </div>
  </div>
</div>
